import { connect } from 'react-redux';

import { IRootState } from '../../../state-mgmt/rootState';
import DownloadsNotifications from './DownloadsNotifications';
import { dashboardState } from 'modules/state-mgmt/dashboard';
import { GeneralModel } from 'modules/models';
import { downloadsState } from 'modules/state-mgmt/downloads';

export const mapStateToProps = (state: IRootState) => ({
  isAuthenticated: state.auth?.authenticated,
  userId: state.user?.accountData?.id,
});

export const mapDispatchToProps = dispatch => ({
  fetchInProgressWidgetExports: (query: GeneralModel.IQueryParams) => dispatch(dashboardState.actions.fetchInProgressWidgetExportsStart(query)),
  // fetchDashboardWidgetDownloads: (query: GeneralModel.IQueryParams) => dispatch(downloadsState.actions.fetchDashboardWidgetDownloadsStart(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadsNotifications);
